import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import client from '../../Services/client'
import Event from '../../components/Events/Event'
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 1200,
    backgroundColor: theme.palette.background.paper,
  },
});

class RecentEvents extends Component {

    state = {
        eventsList: []
    }

    constructor() {
        super()
        this.getNews()
    }
    getNews = () => {
        client.getEntries({
            content_type: 'events',
            limit: 8,
            order: 'sys.createdAt'
        })
        .then((response) => {
            this.setState({eventsList: response.items})
            console.log(this.state.eventsList)
        })
        .catch((error) => {
          console.log("Error occurred while fetching Entries")
          console.error(error)
        })
    }
  render(){
    const { classes } = this.props;
  return (
    <React.Fragment>
      <div>
          <Grid container spacing={20} style={{padding: 10}}>
            {this.state.eventsList.map(event => (
                <Grid item xs={12} sm={6} lg={4} xl={3}>
                    <Event events={event} />
                </Grid>
            ))}
          </Grid>
      </div>
    </React.Fragment>
  );
  }
}

RecentEvents.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RecentEvents);



                


// WEBPACK FOOTER //
// ./src/components/Events/RecentEvents.js